<template>
  <div class="_inputs">
    <label for="minPriceInput">Fra kr.:
      <input
        id="minPriceInput"
        v-model="minPrice"
        type="number"
      >
    </label>
    <label for="maxPriceInput">Til kr.:
      <input
        id="maxPriceInput"
        v-model="maxPrice"
        type="number"
      >
    </label>
  </div>
</template>

<script>
import Residence from '@/models/Residence';

export default {
  name: 'FilterPriceInput',
  computed: {
    minPrice: {
      get() {
        return this.$store.state.entities.residences.minPrice;
      },
      set(minPrice) {
        Residence.commit(state => {
          state.minPrice = parseInt(minPrice);
        });
      },
    },
    maxPrice: {
      get() {
        return this.$store.state.entities.residences.maxPrice;
      },
      set(maxPrice) {
        Residence.commit(state => {
          state.maxPrice = parseInt(maxPrice);
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// FIXME: CSS hack

._inputs {
  display: flex;
  gap: 2em;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;


  input {
    width: auto;
  }
}
</style>